export default class TableOfContents {
  constructor() {
    const toc = document.querySelector(".table-of-contents")
    if (toc) {
      const button = toc.querySelector("button")
      const nav = toc.querySelector("nav")
      const links = nav.querySelectorAll("a")

      button.addEventListener("click", () => {
        nav.classList.toggle("active")
        button.classList.toggle("active")
      })

      document.addEventListener("click", (e) => {
        if (!toc.contains(e.target)) {
          nav.classList.remove("active")
          button.classList.remove("active")
        }
      })

      links.forEach((link) => {
        link.addEventListener("click", () => {
          nav.classList.remove("active")
          button.classList.remove("active")
        })
      })
    }
  }
}
